import { render, staticRenderFns } from "./QustionItems.vue?vue&type=template&id=7e83e058&scoped=true&"
import script from "./question-items.js?vue&type=script&lang=js&"
export * from "./question-items.js?vue&type=script&lang=js&"
import style0 from "./question-items.scss?vue&type=style&index=0&id=7e83e058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e83e058",
  null
  
)

export default component.exports